import type { StickyColor } from "@bedrock/domain";

export const STICKY_COLORS: readonly { value: StickyColor; label: string }[] = [
  { value: "paper", label: "Paper" },
  { value: "cyan", label: "Cyan" },
  { value: "green", label: "Green" },
  { value: "orange", label: "Orange" },
  { value: "blue", label: "Blue" },
  { value: "yellow", label: "Yellow" }
];

export function stickyColorLabel(color: StickyColor): string {
  return STICKY_COLORS.find((option) => option.value === color)?.label ?? "Paper";
}
